'use client';

import { marketplaceNav } from '@/config/marketplaceNav';
import { useAuth } from '@/platform/auth/useAuth';
import { isMarketplaceNavVisible } from './marketplaceNavLogic';
import { useMarketplaceCommunityStatus } from './useMarketplaceCommunityStatus';

export function useMarketplaceNavVisible(): { ready: boolean; visible: boolean } {
  const { user, isLoading } = useAuth();
  const { status } = useMarketplaceCommunityStatus(!!user && !isLoading);

  if (!marketplaceNav.enabled) {
    return { ready: true, visible: false };
  }
  if (!user || isLoading) {
    return { ready: false, visible: false };
  }
  if (!status.ready) {
    return { ready: false, visible: false };
  }

  return {
    ready: true,
    visible: isMarketplaceNavVisible(true, status),
  };
}
